import {connect} from 'react-redux';
import RoomChildrenComponent from "../components/RoomChildrenComponent";
import {availabilityNoOfChildrenChange} from "../actions/AvailabilityActions";

const mapDispatchToProps = dispatch => {
  return {
    onNoOfChildrenChange : (index, noOfChildren) => {
      dispatch(availabilityNoOfChildrenChange(index, noOfChildren));
    }
  }
};

const RoomChildren = connect(null, mapDispatchToProps) (RoomChildrenComponent)

export default RoomChildren;


// WEBPACK FOOTER //
// ./src/containers/RoomChildren.js